import { useEffect } from "react";
import { PaymentStatusType, TOrder } from "@core/types";
import { queryClient } from "../../../config/query-client";
import useGetPaymentQuery from "./useGetPaymentQuery";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const usePaymentStatus = (
  paymentId: string | null,
  paymentStatus: PaymentStatusType | null,
  orderId: TOrder["id"],
  setPaymentStatus: (status: PaymentStatusType | null) => void,
  onSuccess?: () => void,
) => {
  const { t } = useTranslation();
  const getPaymentQuery = useGetPaymentQuery({
    paymentId: paymentId!,
    options: {
      enabled: !!paymentId && paymentStatus === "pending",
      refetchInterval: 1000,
      refetchOnWindowFocus: true,
    },
  });

  const invalidateOrderAndCards = async () => {
    await queryClient.invalidateQueries({ queryKey: ["cards"] });
    await queryClient.invalidateQueries({ queryKey: ["order", orderId] });
    await queryClient.invalidateQueries({ queryKey: ["orders-unpaid"] });
    toast.success(t("Payment successful"));
    onSuccess?.();
  };

  const fetchedPaymentStatus = getPaymentQuery.data?.status as PaymentStatusType;

  useEffect(() => {
    if (fetchedPaymentStatus) {
      setPaymentStatus(fetchedPaymentStatus);
    }
    if (fetchedPaymentStatus === "succeeded") {
      invalidateOrderAndCards();
    }
  }, [fetchedPaymentStatus]);
};

export default usePaymentStatus;
